// @ts-nocheck

import { createContext } from 'react';

import { type GRFullScreenNotification } from '../types/notification';

export type GRHomeContextProps = {
  fullScreenNotifShown: GRFullScreenNotification | null;
  setFullScreenNotifShown: (shown: GRFullScreenNotification | null) => void;
};

export const GRHomeContext = createContext<GRHomeContextProps>({
  fullScreenNotifShown: null,
  setFullScreenNotifShown: () => {},
});
